<template>
  <div v-if="isPermission && isEditData">
    <CCard class="shadow-sm m-2 text-dark">
      <CCardBody>
        <CRow>
          <CCol sm="1" col="2">
            <img src="/img/icon/store.png" style="width: 32px; height: 32px" />
          </CCol>
          <CCol sm="9" col="8">
            <select class="custom-select text-black" v-model="shop" disabled>
              <option v-for="shop in shops" :key="shop.objectId" :value="shop">
                {{ shop.shopName }} - {{ shop.branchName }}
              </option>
            </select>
          </CCol>
          <div class="col-md-2 col-sm-2 col-2 text-right" v-if="loadingButton == true">
            <CButton block color="light" @click="$router.go(-1)">
              <span
                ><i
                  class="fi fi-rr-arrow-left mr-2"
                  style="position: relative; top: 2px"
                ></i></span
              >{{ $t("back") }}
            </CButton>
          </div>
          <div class="col-md-2 col-sm-2 text-right" v-else>
            <CButton block color="success" disabled>
              <CSpinner color="white" size="sm" />{{ $t("loading") }}
            </CButton>
          </div>
        </CRow>
      </CCardBody>
    </CCard>
    <!-- Body information -->
    <CCol md="12" lg="12">
      <CCard class="shadow-sm">
        <CCardBody>
          <CRow class="mb-3">
            <CCol md="6">
              <h2 v-show="isCreateMode" class="font-weight-normal text-dark">
                {{ $t("createPRTXT") }}
              </h2>
              <h2 v-show="isDetailMode" class="font-weight-normal text-dark">
                {{ $t("detailPRTXT") }}
                <CBadge :class="getStatusColor(docStatus)">
                      {{ docStatus }}
                </CBadge>
              </h2>
            </CCol>
          </CRow>

          <!-- Row: PR Number, Supplier, Due Date, Note -->
          <CRow class="align-items-center text-dark">
            <CCol md="3">
              <label class="font-weight-normal text-dark">{{ $t("documentNo") }} :</label>
              <CInput v-model="billNo" :placeholder="$t('documentNo')" disabled />
            </CCol>
            <CCol md="3">
              <label class="font-weight-normal">{{ $t("refNo") }} :</label>
              <CInput v-model="refNo" :placeholder="$t('refNo')" disabled />
            </CCol>
            <CCol md="3" class="pb-3">
              <label class="font-weight-normal">{{ $t("supplier") }} :</label>
              <select
                class="custom-select"
                id="createPRSupplierMultiselect"
                v-model="supplier"
                label="name"
                track-by="name"
                :placeholder="$t('supplier')"
              >
                <option
                  v-for="supplier in supplierList"
                  :key="supplier.id"
                  :value="supplier.id"
                >
                  {{ supplier.name }}
                </option>
              </select>
            </CCol>
            <CCol md="3" class="pb-3">
              <label class="font-weight-normal">{{ $t("dueDate") }} :</label>
              <VueDatePicker
                id="createPRDatePicker"
                color="#29B46B"
                :locale="getDateLocale()"
                :visible-years-number="90"
                v-model="dueDate"
                format="DD-MM-YYYY"
                class="form-control text-dark"
                :disabled="docStatus != 'Pending' && docStatus != 'Create' "
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    id="createPRDatePickerInput"
                    :value="inputValue"
                    v-on="inputEvents"
                  />
                </template>
              </VueDatePicker>
            </CCol>
          </CRow>
          <CRow>
            <CCol md="12">
              <label class="font-weight-normal">{{ $t("transferOutNoteTitle") }} :</label>
              <textarea class="form-control" v-model="note" :placeholder="$t('transferOutNoteTitle')" />
            </CCol>
          </CRow>
          <hr />
          <div class="row">
            <div class="col-9">
              <h4 class="font-weight-normal">
                {{ $t("prItemsList") }}
              </h4>
              <!-- <p class="text-dark">
                {{ $t("เอกสารขอสั่งซื้อสินค้า") }}
              </p> -->
            </div>
            <div v-if="isCreateMode" class="col-3 text-right">
              <CButton
                id="createStockInAddProductButton"
                class="btn btn-outline-success btn-block"
                style="display: flex; align-items: center; justify-content: center"
                @click="AddModal()"
              >
                <i class="fi fi-rr-plus" style="margin-right: 8px"></i
                >{{ $t("addProduct") }}
              </CButton>
            </div>
            <div
              v-if="isDetailMode && docStatus != 'Pending'"
              class="col-3 text-right"
            >
              <CButtonGroup role="group" aria-label="Basic outlined example">
                <CButton
                  color="success"
                  variant="outline"
                  :class="{ 'active-button': selectedTab === 'notPurchased' }"
                  @click="selectedTab = 'notPurchased'"
                  >{{ $t("remainingOrder") }}</CButton
                >
                <CButton
                  color="success"
                  variant="outline"
                  :class="{ 'active-button': selectedTab === 'purchased' }"
                  @click="selectedTab = 'purchased'"
                  >{{ $t("orderedItems") }}</CButton
                >
              </CButtonGroup>
            </div>
          </div>
          <div class="mt-3">
            <table
              id="createStockInTable"
              style="white-space: nowrap"
              v-if="items.length != 0"
              class="table table-sm table-responsive table-bordered mb-4"
            >
              <thead>
                <tr>
                  <th class="text-center text-dark font-weight-normal">#</th>
                  <th></th>
                  <th class="text-dark font-weight-normal">{{ $t("pluCode") }}</th>
                  <th class="text-dark font-weight-normal">{{ $t("productName") }}</th>
                  <th class="text-dark font-weight-normal">{{ $t("unit") }}</th>
                  <th class="text-right text-dark font-weight-normal">
                    {{ $t("prQty") }}
                  </th>
                  <th v-show="selectedTab === 'purchased'" class="text-right text-dark font-weight-normal">
                    {{ $t("poQty") }}
                  </th>
                  <th class="text-right text-dark font-weight-normal">
                    {{ $t("stockUnit") }}
                  </th>
                  <th class="text-right text-dark font-weight-normal">
                    {{ $t("discount") }}
                  </th>
                  <th class="text-right text-dark font-weight-normal">
                    {{ $t("total") }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in filterItemsStatus"
                  :key="index"
                  :id="'createStockInTableRow' + index"
                >
                  <td
                    :id="'createPRIndex' + index"
                    style="width: 2%"
                    class="text-center text-dark font-weight-normal"
                    :value="(item.orderIndex = index)"
                  >
                    <div style="margin-top: 6px">
                      {{ index + 1 }}
                    </div>
                  </td>
                  <td :id="'createPRImageCol' + index" style="width: 5%">
                    <div
                      v-if="item.remoteImagePath"
                      :style="{
                        'background-image': `url('${item.remoteImagePath}'), url('${noImg}')`,
                        'background-size': 'cover',
                        'background-position': 'center center',
                        width: 'auto',
                        'border-radius': '2px',
                        'aspect-ratio': '1.3',
                        'min-width': '50px',
                      }"
                    ></div>
                    <div
                      :id="'createPRPlaceholderImage' + index"
                      v-else
                      style="border-radius: 2px"
                      :style="{
                        'aspect-ratio': '4 / 3',
                        'min-width': '50px',
                        backgroundColor: item.indexColor,
                      }"
                    ></div>
                  </td>
                  <td :id="'createPRPLUCodeCol' + index">
                    <div class="text-dark font-weight-normal" style="margin-top: 6px">
                      {{ item.productPLU.PLUCode || "" }}
                    </div>
                  </td>
                  <td style="width: 30%" :id="'createStockInNameCol' + index">
                    <div
                      :id="'createPRName' + index"
                      class="text-dark font-weight-normal"
                      style="margin-top: 6px"
                    >
                      <span v-if="item.vatType === 'N'"
                        >{{ item.productPLU.name || "" }}
                        <CBadge color="danger">Non VAT</CBadge></span
                      >
                      <span v-else> {{ item.productPLU.name || "" }} </span>
                    </div>
                  </td>
                  <td>
                    <div class="text-dark font-weight-normal" style="margin-top: 6px">
                      {{
                        item.productPLU.unit ? item.productPLU.unit.name || "-" : "-"
                      }}/{{ item.productPLU.SKURatio || "1" }}
                    </div>
                  </td>
                  <td>
                    <input
                      :id="'createStockInQuantity' + index"
                      style="width: 100%; height: 100%"
                      type="number"
                      min="0"
                      v-model.number="item.quantity"
                      class="form-control form-control-md text-right text-dark font-weight-normal"
                      :disabled="isDetailMode && item.status != 'Pending'"
                    />
                    <p
                      class="text-dark font-weight-normal"
                      v-if="
                        Number(item.quantity) < 0 || Number.isNaN(parseInt(item.quantity))
                      "
                    >
                      {{ $t("dialogfound") }}
                    </p>
                  </td>
                  <td v-show="selectedTab === 'purchased'">
                    <input
                      :id="'createStockInQuantity' + index"
                      style="width: 100%; height: 100%"
                      type="number"
                      min="0"
                      v-model.number="item.ordered"
                      class="form-control form-control-md text-right text-dark font-weight-normal"
                      :disabled="isDetailMode && item.status != 'Pending'"
                    />
                  </td>
                  <td>
                    <input
                      :id="'createStockInCost' + index"
                      style="width: 100%; height: 100%"
                      type="number"
                      min="0"
                      class="form-control form-control-md text-right text-dark font-weight-normal"
                      v-model.number="item.cost"
                      :disabled="isDetailMode && item.status != 'Pending'"
                    />
                  </td>
                  <td>
                    <input
                      :id="'createStockInDiscountItem' + index"
                      style="width: 100%; height: 100%"
                      type="number"
                      min="0"
                      class="form-control form-control-md text-right text-danger font-weight-normal"
                      v-model.number="item.discount"
                      :disabled="isDetailMode && item.status != 'Pending'"
                    />
                  </td>
                  <td>
                    <input
                      :id="'createStockInGrandTotalItem' + index"
                      style="width: 100%; height: 100%"
                      class="form-control form-control-md text-right text-dark font-weight-normal"
                      :value="grandTotalItem(item)"
                      disabled
                    />
                  </td>
                  <td class="text-center" style="width: 2%">
                    <CButton
                      :id="'createPRRemoveItem' + index"
                      color="danger"
                      size="sm"
                      @click="removeProduct(item)"
                    >
                      <CIcon name="cil-trash"></CIcon>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
            <CDataTable v-else id="createStockInEmptyTable">
              <template #no-items-view>
                <div class="text-center my-5">
                  <h4 style="color: #ced2d8">
                    {{ $t("noItem") }}
                  </h4>
                </div>
              </template>
            </CDataTable>

            <div v-if="validateItem" class="text-danger">
              {{ validateItem }}
            </div>
            <p class="text-danger" v-if="warning != ''">{{ warning }}</p>
            <p v-if="duplicateItem != ''" class="text-danger">
              {{ duplicateItem }}
            </p>
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- Footer button -->
    <CCol>
      <div class="row justify-content-end mb-4" style="margin: 0">
        <CButton
          v-if="docStatus != 'Pending'"
          id="createPRCancel"
          class="btn col-lg-2 col-4 shadow-sm text-dark font-weight-normal"
          style="background-color: white; margin-right: 15px"
          @click="$router.go(-1)"
        >
          {{ $t("cancel") }}
        </CButton>
        <CButton
          v-else
          id="createPRCancel"
          class="btn col-lg-2 col-4 shadow-sm font-weight-normal"
          color="danger"
          style="color: white; margin-right: 15px"
          @click="deleteModal = true"
        >
          {{ $t("deleteDoc") }}
        </CButton>
        <CButton
          id="createPRHandlepopup"
          class="btn btn-success col-lg-2 col-4 font-weight-normal"
          @click="handlePopup"
          :disabled="items.length === 0"
        >
          {{ $t("save") }}
        </CButton>
      </div>
    </CCol>

    <!-- Delete Modal-->
    <CRow>
      <CModal id="checkStockDetailDeleteModal" :show.sync="deleteModal" color="danger" :title="$t('confirmDeleteDoc')" centered :footer="deleteFooter">
        <br />
        <h4 class="text-center">
          {{ $t('confirmDeleteModal') }}
        </h4>
        <br />
        <template #footer>
          <CRow class="justify-content-center col-md-12">
            <CCol col="4">
              <CButton id="checkStockDetailDeleteButton" block color="danger" v-if="loadingButton === true"
                v-on:click="deletePRDocument(docObjectId)">
                {{ $t('confirm') }}
              </CButton>
              <CButton id="checkStockDetailDeleteDisabledButton" block color="danger" v-else-if="loadingButton === false" disabled>
                <CSpinner color="white" size="sm" /> {{ $t('confirm') }}
              </CButton>
            </CCol>
            <CCol col="2"></CCol>
            <CCol col="4">
              <CButton id="checkStockDetailDeleteCancelButton" block color="light" @click="deleteModal = false">
                {{ $t('cancel') }}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
    </CRow>
    <!-- Confirm modal -->
    <CRow>
      <CModal
        id="createPRPopupModal"
        :show.sync="popupModal"
        color="success"
        :title="$t('confirmSaveDoc')"
        centered
        :footer="footer"
      >
        <br />
        <h4 class="text-center">{{ $t("confirmSavePRDoc") }}</h4>
        <br />
        <template #footer>
          <CRow class="justify-content-around col-md-12">
            <CCol col="6">
              <CButton
                id="createPRCancelButton"
                block
                color="light"
                @click="popupModal = false"
                class="font-weight-normal"
              >
                {{ $t("cancel") }}
              </CButton>
            </CCol>
            <CCol col="6">
              <CButton
                id="createPRSaveButton"
                block
                color="success"
                v-if="loadingButton === true"
                v-on:click="$router.push('/inventory/purchase/pr')"
              >
                {{ $t("save") }}
              </CButton>
              <CButton
                id="createPRSaveDisabledButton"
                block
                color="success"
                v-else-if="loadingButton === false"
                disabled
              >
                <CSpinner color="white" size="sm" /> {{ $t("save") }}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
    </CRow>

    <!-- Select Product modal -->
    <CRow>
      <CModal
        id="createPRAddProductModal"
        :show.sync="AddProductModal"
        centered
        style="max-width: 915px"
        :footer="footer"
        size="lg"
      >
        <template #header-wrapper class="header-modal">
          <header class="modal-header header-modal">
            <h4 class="modal-title font-weight-normal">
              {{ $t("selectdProduct") }}
            </h4>
            <button
              id="createPRModalCloseButton"
              type="button"
              aria-label="Close"
              class="close"
              @click="AddProductModal = false"
            >
              ×
            </button>
          </header>
        </template>
        <template #body-wrapper>
          <CCardBody>
            <CAlert color="danger" :show.sync="isshowAlert" closeButton>
              {{ $t("limitItems") }}
            </CAlert>
            <CRow class="mb-3">
              <label class="col-sm-1 col-form-label text-left text-dark">
                {{ $t("search") }}
              </label>
              <CCol style="padding-right: 0">
                <select
                  id="createPRSearchBySelect"
                  v-model="searchBy"
                  class="custom-select no-border-radius-left"
                >
                  <option value="PLUCode">{{ $t("pluCode") }}</option>
                  <option value="name">{{ $t("productName") }}</option>
                  <option value="category">{{ $t("category") }}</option>
                </select>
              </CCol>
              <CCol class="pl-0 col-6">
                <template v-if="searchBy === 'category'">
                  <select
                    id="createPRCategorySelect"
                    v-model="selectedCategory"
                    class="form-control text-dark no-border-radius-right"
                  >
                    <option selected disabled value="">{{ $t("selectCategory") }}</option>
                    <option
                      :id="'createPRCategoryOption' + index"
                      v-for="(category, index) in dataCategory"
                      :key="category.objectId"
                      :value="category.objectId"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                </template>
                <template v-else>
                  <input
                    id="createPRSearchInput"
                    class="form-control text-dark no-border-radius-right"
                    v-model="keywordEntered"
                    @input="searchProductPLU"
                    :placeholder="$t('searchProduct')"
                  />
                </template>
              </CCol>
              <CCol class="p-0">
                <CButton
                  id="createPRSearchButton"
                  block
                  color="success"
                  v-if="loadingButton === true"
                  v-on:click="searchProductPLU"
                >
                  {{ $t("search") }}
                </CButton>
              </CCol>
              <CCol class="pl-1">
                <CButton
                  id="createPRResetButton"
                  class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="color: black; width: inherit"
                  v-on:click="reset"
                >
                  {{ $t("reset") }}
                </CButton>
              </CCol>
            </CRow>
            <div v-if="checkAllAlert" class="alert alert-warning  mt-2 mb-0" style="font-size: 13px;">
              <i class="fi fi-rr-info mr-1"></i> การเลือกทั้งหมด จะเลือกเฉพาะสินค้าในหน้านี้เท่านั้น หากต้องการเลือกสินค้าเพิ่ม กรุณาเปลี่ยนหน้าแล้วเลือกเพิ่มเติม
            </div>
            <div style="max-height: 400px; overflow-y: auto" class=" text-dark">
              <CDataTable
                id="createPRDataTable"
                class="text-dark"
                :fields="fields"
                :items="autoCompleteResult"
                hover
                v-model="autoCompleteResult"
                border
                clickableRows
                @row-clicked="onSelectedAutoCompleteEvent"
              >
                <template slot="selected-header">
                  <div
                    class="custom-control custom-checkbox text-dark"
                    style="padding-left: 2rem"
                  >
                    <input
                      v-model="all"
                      type="checkbox"
                      @change="setAll()"
                      class="custom-control-input success cursor"
                      id="yyy"
                    />
                    <label class="custom-control-label cursor" for="yyy"> </label>
                  </div>
                </template>
                <template #selected="{ item, index }">
                  <td :id="'createPRSelectedCell' + index" style="vertical-align: middle">
                    <div
                      class="custom-control custom-checkbox text-dark"
                      style="padding-left: 2rem"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input success cursor"
                        :disabled="item.inDocument" v-model="item.selected"
                        @change="onSelectedAutoCompleteEvent(item)"
                        :id="index"
                      />
                      <label class="custom-control-label cursor" :for="index"> </label>
                    </div>
                  </td>
                </template>
                <template #name="{ item, index }">
                  <td style="vertical-align: middle; border-left: hidden" :for="index">
                    <img
                      v-if="item.remoteImagePath"
                      :src="item.remoteImagePath"
                      style="border-radius: 2px; aspect-ratio: 4 / 3"
                      class="img-fluid"
                      @error="noImgUrl"
                    />
                    <div
                      v-else
                      style="border-radius: 2px"
                      :style="{
                        'aspect-ratio': '4 / 3',
                        backgroundColor: item.indexColor,
                      }"
                    ></div>
                  </td>
                </template>
                <template #nameproduct="{ item }">
                  <td
                    class="text-dark font-weight-normal"
                    style="vertical-align: middle; border-left: hidden"
                  >
                    {{ item.name }}
                  </td>
                </template>
                <template #categoryName="{ item }">
                  <td
                    class="text-dark font-weight-normal"
                    style="vertical-align: middle; border-left: hidden"
                  >
                    {{ item.categoryName }}
                  </td>
                </template>
                <template #pluCode="{ item }">
                  <td
                    class="text-dark font-weight-normal"
                    style="vertical-align: middle; border-left: hidden"
                  >
                    {{ item.PLUCode }}
                  </td>
                </template>
                <template #price="{ item, index }">
                  <td
                    class="text-dark font-weight-normal"
                    :for="index"
                    style="vertical-align: middle; border-left: hidden"
                    v-if="
                      item.ProductSKU.stdCost === '' ||
                      item.ProductSKU.stdCost === undefined
                    "
                  >
                    ฿ 0
                  </td>
                  <td
                    class="text-dark font-weight-normal"
                    :for="index"
                    style="vertical-align: middle; border-left: hidden"
                    v-else
                  >
                    ฿ {{ item.ProductSKU.stdCost }}
                  </td>
                </template>
                <template #onhanQTY="{ item, index }">
                  <td
                    class="text-right"
                    :for="index"
                    style="vertical-align: middle; border-left: hidden"
                    v-if="
                      item.ProductPLUStock.onhandQty === '' ||
                      item.ProductPLUStock.onhandQty === undefined
                    "
                  >
                    N/A
                  </td>
                  <td
                    class="text-right"
                    :for="index"
                    style="vertical-align: middle; border-left: hidden"
                    v-else
                  >
                    <div
                      v-if="
                        item.ProductPLUStock.onhandQty < 0 &&
                        Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))
                      "
                      class="text-danger"
                    >
                      {{ parseFloat(item.ProductPLUStock.onhandQty) }}
                    </div>
                    <div
                      v-else-if="
                        item.ProductPLUStock.onhandQty < 0 &&
                        !Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))
                      "
                      class="text-danger"
                    >
                      {{ parseFloat(item.ProductPLUStock.onhandQty).toFixed(3) }}
                    </div>
                    <div
                      v-else-if="
                        !Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))
                      "
                      class="text-dark"
                    >
                      {{ parseFloat(item.ProductPLUStock.onhandQty).toFixed(3) }}
                    </div>
                    <div v-else class="text-dark">
                      {{ parseFloat(item.ProductPLUStock.onhandQty) }}
                    </div>
                  </td>
                </template>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8">
                      {{ $t("noItem") }}
                    </h4>
                  </div>
                </template>
              </CDataTable>
            </div>
            <pagination :meta_data="meta_data_product" v-on:next="searchProductPLU">
            </pagination>
          </CCardBody>
        </template>
        <template #footer-wrapper>
          <CRow class="justify-content-end col-md-12">
            <CCol col="12" lg="6" class="row">
              <div class="col-6">
                <CButton
                  id="createPRCancelModalButton"
                  class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="color: black; width: inherit"
                  @click="AddProductModal = false"
                >
                  {{ $t("cancel") }}
                </CButton>
              </div>
              <div class="col-6">
                <CButton
                  id="createPRConfirmModalButton"
                  block
                  color="success"
                  v-if="loadingButton === true"
                  v-on:click="onCheckboxChange"
                >
                  {{ $t("confirm") }}
                </CButton>
                <CButton
                  id="createPRConfirmDisabledModalButton"
                  block
                  color="success"
                  v-else-if="loadingButton === false"
                  disabled
                >
                  <CSpinner color="white" size="sm" /> {{ $t("save") }}
                </CButton>
              </div>
            </CCol>
          </CRow>
          <br />
        </template>
      </CModal>
    </CRow>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "@/services/local";
import util from "@/util/util";
import Multiselect from "vue-multiselect";
import permis from "@/util/permission";
import pos from "@/services/local";
import Pagination from "@/containers/Pagination";

export default {
  components: {
    Multiselect,
    Pagination,
  },
  data() {
    return {
      checkAllAlert: false,
      meta_data_product: {
        last_page: null,
        current_page: 1,
        items: 0,
        limit: 20,
        itemCount: null,
      },
      deleteFooter: '',
      deleteModal: false,
      selectedTab: "notPurchased",
      isSuccess: false,
      alert: false,
      data: [],
      datetime: new Date(),
      shop: this.$store.getters.shopObjectId,
      member: null,
      members: [],
      isVatIncluded: false,
      isAVGCostCalc: false,
      billNo: "",
      note: "",
      discount: "0",
      searchBy: "name",
      label: "name",
      keyword: "",
      placeHolderInputText: "พิมพ์ชื่อสินค้าที่ต้องการค้นหา .​.​.",
      autoCompleteResult: [],
      autoCompleteProgress: false,
      autoCompleteText: "name",
      autoCompleteText2: "PLUCode",
      autoCompleteText3: "unitName",
      autoCompleteFieldId: "alpha3Code",
      items: [],
      vatType: "",
      validateShop: "",
      validateItem: "",
      popupModal: false,
      footer: "",
      loadingButton: true,
      duplicateItem: "",
      warning: "",
      permission: false,
      AddProductModal: false,
      AddCheckStockModal: false,
      keywordEntered: "",
      selectedItems: [],
      all: false,
      isshowAlert: 0,
      dataCategory: [],
      selectedCategory: "",
      supplier: null,
      supplierList: [
        { name: "Coke Shop", id: 1 },
        { name: "RK Shop", id: 2 },
      ],
      dueDate: new Date(),
      docStatus: "Create",
      refNo: ''
    };
  },
  computed: {
    ...mapGetters(["shops", "users", "date", "access", "permissions"]),
    uid() {
      return `${localStorage.getItem("shopsUid")}`;
    },
    isPermission() {
      let path = "/inventory/stock-in";
      return permis.findPermissionRead("inventory", path);
    },
    isEditData() {
      let path = "/inventory/stock-in";
      return permis.findPermissionEdit("inventory", path);
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    startDate() {
      return moment(String(this.date.start)).format("DD MMMM YYYY");
    },
    shopOptions() {
      let detail = [];
      this.shops.forEach((shop) => {
        detail.push({
          value: shop,
          label: shop.shopName + " - " + shop.branchName,
        });
      });
      return detail;
    },
    memberOptions() {
      let detail = [];
      this.members.forEach((member) => {
        detail.push({
          value: member,
          label: member.name,
        });
      });
      return detail;
    },
    noImg() {
      return process.env.VUE_APP_NOIMAGE;
    },
    fields() {
      return [
        {
          key: "selected",
          label: this.$i18n.t("selectd"),
          _style: "width:5%; vertical-align: middle; text-dark",
          _classes: "text-left font-weight-normal text-dark",
        },
        {
          key: "name",
          label: "",
          _style: "width:7%; vertical-align: middle;border-left: hidden text-dark",
          _classes: "text-left font-weight-normal text-dark",
        },
        {
          key: "nameproduct",
          label: this.$i18n.t("product"),
          _style: "width:30%; vertical-align: middle;border-left: hidden text-dark",
          _classes: "text-left font-weight-normal text-dark",
        },
        {
          key: "pluCode",
          label: this.$i18n.t("pluCode"),
          _style: "width:25%; vertical-align: middle;border-left: hidden text-dark",
          _classes: "text-left font-weight-normal text-dark",
        },
        {
          key: "categoryName",
          label: this.$i18n.t("category"),
          _style: "width:23%; vertical-align: middle;  text-dark",
          _classes: "text-left font-weight-normal text-dark",
        },
        {
          key: "onhanQTY",
          label: this.$i18n.t("onhandQty"),
          _classes: "text-right font-weight-normal text-dark",
          _style: "width:30%; vertical-align: middle;border-left: hidden text-dark",
        },
      ];
    },
    memberslist() {
      const member = this.members || [];
      let detail = [];
      for (let i = 0; i < member.length; i++) {
        const item = member[i];
        const fullName =
          (item.firstname || item.name || "") + " " + (item.lastname || "");
        detail.push({
          id: item.id,
          objectId: item.objectId,
          name: fullName,
        });
      }
      return detail;
    },
    isCreateMode() {
      return this.$route.path.includes("/createPRDocument");
    },

    isDetailMode() {
      return this.$route.path.includes("/inventory/purchase/PRDocument/");
    },
    idPrefix() {
      return this.isCreateMode ? "createPR" : "detailPR";
    },
    objectId() {
      return this.isDetailMode ? this.$route.params.objectId : null;
    },
    filterItemsStatus() {
      if (this.isCreateMode) {
        return this.items; // กรณีสร้างใหม่ให้แสดง items ทั้งหมด
      }
      return this.selectedTab === "notPurchased"
        ? this.items.filter(
            (item) => item.status === "Pending" || 
                      item.status === "Canceled" 
          )
        : this.items.filter(
            (item) =>
              item.status === "Completed" ||
              item.status === "In Progress"
          );
    },
    docObjectId(){
      return this.$route.params.objectId
    }
  },
  created() {
    this.getMember();
    this.shop = this.shops.find((i) => i.objectId === this.shop);
    if (this.isDetailMode && this.objectId) {
      this.getPRDoc();
    }
    if (this.isCreateMode) {
      this.selectedTab = "notPurchased"; // กรณีสร้างใหม่ให้แสดงใน notPurchased
    } else if (this.docStatus === 'Completed') {
      this.selectedTab = "notPurchased";
    } else {
      this.selectedTab = "purchased";
    }
  },
  watch: {
    docStatus(newStatus) {
      if (!this.isCreateMode) {
        if (newStatus === "In Progress" || newStatus === "Pending") {
          this.selectedTab = "notPurchased";
        } else {
          this.selectedTab = "purchased";
        }
      }
    },
  },
  methods: {
    ...util,
    AddModal() {
      this.keywordEntered = ''
      this.autoCompleteResult = []
      this.all = false
      this.searchProductPLU()
      this.AddProductModal = true
    },
    getDateLocale() {
        return this.$i18n.locale
    },
    noImgUrl(event) {
      event.target.src = process.env.VUE_APP_NOIMAGE;
    },
    reset() {
      this.selectedItems = [];
      this.all = false;
      this.keywordEntered = "";
      this.searchBy = "name";
      this.selectedCategory = "";
      this.searchProductPLU();
    },
    handlePopup() {
      if (this.shopObjectId === "") {
        this.popupModal = false;
        this.validateShop = this.$i18n.t("selectShopPlease");
      } else {
        this.validateShop = "";
      }

      if (this.items.length === 0) {
        this.popupModal = false;
        this.validateItem = this.$i18n.t("selectProductPlease");
      } else {
        this.validateItem = "";
      }

      if (this.items.length != 0 && this.shopObjectId != "") {
        this.popupModal = true;
      }
    },
    removeProduct(i) {
      let items = this.items;
      let newItems = items.filter((item) => item.orderIndex != i.orderIndex);
      this.items = newItems;
      let index = this.autoCompleteResult.findIndex(
        (x) => x.objectId == i.productPLU.objectId
      );
      if (index != -1) {
        this.autoCompleteResult[index].selected = false;
      }

      let find = this.selectedItems.findIndex(
        (x) => x.objectId === i.productPLU.objectId
      );
      if (find != -1) {
        this.selectedItems.splice(i, 1);
      }
    },
    grandTotalItem(item) {
      let total = 0;
      if (item.vatType === "N") {
        total = item.quantity * item.cost - item.discount;
      }
      if (item.vatType === "V") {
        total = item.quantity * item.cost - item.discount;
      } else {
        total = item.quantity * item.cost - item.discount;
      }
      return (item.total = total);
    },
    getMember() {
      const uid = this.uid;
      const shopObjectId = this.shopObjectId;

      const params = {
        shopObjectId: shopObjectId,
      };
      const headers = {
        shopObjectId: shopObjectId,
      };
      axios({
        url: "/api/v1.0/" + uid + "/getmember",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.members = res.data.data.documents;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSelectedAutoCompleteEvent(item) {
      if (item.inDocument) return
      let cont = 0;
      this.autoCompleteResult.forEach(function (item) {
        if (item.selected) {
          cont = cont + 1;
        }
      });
      if (cont < 200) {
        item.selected = !item.selected;
        if (item.selected) {
          this.selectedItems.push(item);
        } else {
          let i = this.selectedItems.findIndex((x) => x.objectId === item.objectId);
          if (i != -1) {
            this.selectedItems.splice(i, 1);
          }
        }
        let countItem = this.autoCompleteResult.length;
        let coutselect = 0;
        this.autoCompleteResult.forEach((item) => {
          if (item.selected) {
            coutselect = coutselect + 1;
          }
        });
        if (countItem === coutselect) {
          this.all = true;
        } else {
          this.all = false;
        }
      } else {
        this.isshowAlert = 5;
      }
    },
    searchProductPLU(page) {
      if (this.shopObjectId === "") {
        this.validateShop = this.$i18n.t("selectShopPlease");
      } else {
        this.validateShop = "";
      }

      const uid = `${localStorage.getItem("shopsUid")}`;
      let params = {};
      if (this.searchBy === "category" && this.selectedCategory) {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          categoryObjectId: this.selectedCategory,
          page: page || 1,
          limit: 50,
        };
      } else if (this.keywordEntered != "") {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          searchBy: this.searchBy,
          keyword: this.keywordEntered,
          page: page || 1,
          limit: 50,
        };
      } else {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          searchBy: this.searchBy,
          page: page || 1,
          limit: 50,
        };
      }
      this.label = this.searchBy;
      let selectedItems = this.selectedItems;
      // if (keywordEntered.length > 0) {
      const headers = { shopObjectId: this.$store.getters.shopObjectId };
      axios({
        url: "/api/v1.0/" + uid + "/getproductpluwithstock/paginate",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((response) => {
          this.alert = false;
          const paginate = response.data.paginate || {};
          this.meta_data_product.items = paginate.items || 0;
          this.meta_data_product.last_page = paginate.pageCount || 0;
          this.meta_data_product.current_page = paginate.currentPage || 0;
          this.meta_data_product.itemCount = paginate.itemCount || 0;
          this.meta_data_product.limit = paginate.perPage || 20;
          let newData = [];
          response.data.data.forEach((item) => {
            if (selectedItems.length > 0) {
              let i = selectedItems.findIndex((x) => x.objectId === item.objectId);
              if (i != -1) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else {
              item.selected = false;
            }
            let inDoc = (this.items || []).findIndex(x => (x.productPLU?.objectId || x.productPLU?.id) === item.objectId) !== -1
            if (inDoc) { item.selected = true; item.inDocument = true } else { item.inDocument = false }
            const unit = item.unit || {};
            const category = item.category || {};
            item.unitName = unit.name || "-";
            item.categoryName = category.name || "-";
            item.indexColor = util.generateColor(item.ProductSKU.indexColor);
            newData.push(item);
          });
          this.autoCompleteResult = newData;
          this.all = newData.length > 0 && newData.every(item => item.selected)
        })
        .catch((e) => {
          this.alert = true;
          console.log(e);
        });
      // }
    },
    formSubmit(e) {
      this.loadingButton = false;
      this.shop = this.shops.find((i) => i.objectId === this.shopObjectId);
      e.preventDefault();

      const plan = this.users.currentPlan;
      this.items.forEach((item) => {
        delete item.remoteImagePath;
        delete item.indexColor;
      });

      let data = {
        billNo: this.billNo,
        date: new Date(this.datetime).toISOString(),
        discount: util.currencyStringToNumber(this.discount),
        grandTotal: util.currencyStringToNumber(this.grandTotal),
        isVatIncluded: !this.isVatIncluded,
        netTotal: this.netTotal,
        note: this.note,
        shop: {
          id: this.shop.id,
          objectId: this.shop.objectId,
          shopName: this.shop.shopName,
          branchName: this.shop.branchName,
        },
        shopId: this.shop.id,
        stockDocType: 1,
        vatBase: 7,
        uid: this.uid,
        vat: this.vat,
        items: this.items,
        vatType: this.vatType,
      };

      if (this.member != null) {
        data["customerId"] = this.member.id || "";
        data["customer"] = {
          id: this.member.id || "",
          objectId: this.member.objectId || "",
          name: this.member.name || "",
        };
      }

      const headers = { shopObjectId: this.$store.getters.shopObjectId };
      if (data.shopId != undefined && data.items.length != 0) {
        axios({
          method: "post",
          url: "",
          params: { shopObjectId: data.shopObjectId, plan: plan },
          data: data,
          headers: headers,
        })
          .then(() => {
            // setTimeout(() => {
            //   (this.isSuccess = true),
            this.isSuccess = true;
            this.$router.push("/inventory/purchase/pr");
            // }, 5000);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    onCheckboxChange() {
      let data = this.selectedItems;
      let items = this.items;
      let select = [];
      let isshowAlert = 0;
      data.forEach((item, index) => {
        if (items.length < 200) {
          let stdCost = 0;
          let SKURatio = 1;
          let totalCost = 0;
          if (item.selected) {
            select.push(item);
            if (
              item.ProductSKU.stdCost === undefined ||
              item.ProductSKU.stdCost === null
            ) {
              stdCost = 0;
            } else {
              stdCost = item.ProductSKU.stdCost;
            }

            if (item.SKURatio == undefined) {
              SKURatio = 1;
            } else {
              SKURatio = item.SKURatio;
            }

            totalCost = SKURatio * stdCost;
            let checkCount = item.checkCount;
            let quantity = checkCount !== undefined ? checkCount : 0;
            let vatType = item.ProductSKU.vatType;
            if (items.length > 0) {
              let i = items.findIndex((x) => x.productPLU.objectId === item.objectId);
              if (i == -1) {
                items.push({
                  cost: totalCost,
                  discount: 0,
                  orderIndex: index,
                  productPLU: {
                    id: item.id,
                    objectId: item.objectId,
                    PLUCode: item.PLUCode,
                    name: item.name,
                    unit: item.unit,
                    SKURatio: SKURatio,
                  },
                  productPLUId: item.id,
                  quantity: quantity,
                  total: 0,
                  productSKUObjectId: item.ProductSKU.objectId,
                  productSKU: item.ProductSKU || {},
                  remoteImagePath: item.remoteImagePath,
                  indexColor: util.generateColor(item.indexColor),
                  vatType: vatType,
                });
              }
            } else {
              items.push({
                cost: totalCost,
                discount: 0,
                orderIndex: index,
                productPLU: {
                  id: item.id,
                  objectId: item.objectId,
                  PLUCode: item.PLUCode,
                  name: item.name,
                  unit: item.unit,
                  SKURatio: SKURatio,
                },
                productPLUId: item.id,
                quantity: quantity,
                total: 0,
                productSKUObjectId: item.ProductSKU.objectId,
                productSKU: item.ProductSKU || {},
                remoteImagePath: item.remoteImagePath,
                indexColor: util.generateColor(item.indexColor),
                vatType: vatType,
              });
            }
          } else {
            let index = items.findIndex((x) => x.productPLU.objectId === item.objectId);
            if (index != -1) {
              items.splice(index, 1);
            }
          }
        } else {
          isshowAlert = 5;
        }
      });
      this.isshowAlert = isshowAlert;
      this.items = items;
      this.selectedItems = select;
      this.AddProductModal = false;
      this.AddCheckStockModal = false;
      this.all = false;
      console.log(this.items, 'items')
    },
    setAll() {
      let select = this.selectedItems;
      let data = this.autoCompleteResult;
      let isshowAlert = 0;

      // this.selectedItems = []
      if (this.all) {
        this.checkAllAlert = true
        data.forEach((item) => {
          if (item.inDocument) return
          let cont = select.length;
          if (cont < 200) {
            item.selected = true;
            if (select.findIndex(x => x.objectId === item.objectId) === -1) select.push(item)
          } else {
            this.checkAllAlert = false
            isshowAlert = 5;
          }
        });
      } else {
        data.forEach((item) => {
          if (item.inDocument) return
          item.selected = false;
          let i = select.findIndex((x) => x.objectId === item.objectId);
          if (i != -1) {
            select.splice(i, 1);
          }
        });
      }
      this.isshowAlert = isshowAlert;
      this.selectedItems = select;
      this.autoCompleteResult = data;
    },
    getPRDoc() {
      const uid = this.uid;
      const shopObjectId = this.shopObjectId;
      const params = { shopObjectId: shopObjectId };
      const docObjectId = this.$route.params.objectId;
      let url = "http://localhost:3002/pr" + "?objectId=" + docObjectId;

      const headers = { shopObjectId: this.$store.getters.shopObjectId };

      axios
        .get(url, { params, headers })
        .then((res) => {
          this.detail = res.data;
          this.billNo = this.detail.docNo;
          this.supplier = this.detail.supplier;
          this.items = this.detail.items;
          this.docStatus = this.detail.status;
          this.refNo = this.detail.refNo || 'PO001'
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
        });
    },
    getStatusColor(status) {
      switch (status) {
        case "Completed":
          return "status-success"; // สี success จางลง
        case "Canceled":
          return "status-danger"; // สี danger จางลง
        case "Pending":
          return "status-light"; // สี light
        case "In Progress":
          return "status-primary"; // สี primary จางลง
        default:
          return "status-light"; // สีเทา
      }
    },
    deletePRDocument(){
      this.$router.push('/inventory/purchase/pr')
    }
  },
};
</script>
<style scoped>
.no-border-radius-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}
.active-button {
  background-color: var(--success) !important; /* สีเขียวอ่อน */
  color: white !important;
  font-weight: normal;
  border-color: none!important;
}
.no-border-radius-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.multiselect__tags {
  min-height: 35px;
  padding: 0px 40px 0 8px;
}

.multiselect__placeholder {
  margin-top: 6px;
  margin-bottom: 7px;
}

.multiselect__single {
  margin-top: 6px;
  padding-left: 5px;
  margin-bottom: 8px;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

/* Hidden arrow  */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.status-success {
  background-color: rgba(40, 167, 69, 0.5) !important; /* Success จาง */
  color: #155724; 
  border-radius: 10px;
}

.status-danger {
  background-color: rgba(220, 53, 69, 0.5) !important; /* Danger จาง */
  color: #721c24;
  border-radius: 10px;
}

.status-light {
  background-color: #e0e0e0 !important; /* Light */
  color: #6c757d;
  border-radius: 10px;
}

.status-primary {
  background-color: rgba(0, 123, 255, 0.5) !important; /* Primary จาง */
  color: #004085;
  border-radius: 10px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="../../../assets/styles/inventory.css" scoped></style>
